import React, { useContext } from 'react';
import { GlassWater, Cake, Music } from 'lucide-react';
import { LanguageContext } from '../LanguageContext';

const Footer: React.FC = () => {
    const { language } = useContext(LanguageContext);

    // Text content for both languages
    const text = {
        ro: {
            footer: "Abia așteptăm să sărbătorim împreună cu voi!",
            contact: "Pentru orice întrebări, vă rugăm să ne contactați la"
        },
        en: {
            footer: "We can't wait to celebrate with you!",
            contact: "For any questions, please contact us at"
        }
    };

    return (
        <footer className="text-center py-8 bg-white border-t border-gray-200">
            <p className="text-gray-800 font-medium">
                {text[language].footer}
            </p>
            <p className="text-sm text-gray-600 mt-2">
                {text[language].contact}
            </p>
            <div className="flex items-center justify-center gap-2 mt-1">
                <a href="tel:+40748830679" className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors duration-300">
                    <span className="mr-1">📞</span>
                    <span className="font-medium">+40 748 830 679</span>
                </a>
            </div>

            <div className="border-t border-gray-200 pt-8 max-w-xl mx-auto text-center">
                <div className="inline-flex items-center">
                    <img src="/images/flowers.svg" alt="" className="h-6 w-6 opacity-60 mx-2" />
                    <img src="/images/cake.svg" alt="" className="h-6 w-6 opacity-60 mx-2" />
                    <img src="/images/flowers.svg" alt="" className="h-6 w-6 opacity-60 mx-2" />
                </div>
            </div>
        </footer>
    );
};

export default Footer;